
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetobanglorecab() {



    const cardData =
    {
        keyword: ' Pune to Bangalore Cab',
        heading: 'Prince Cabs: Pune to Bangalore Cab',
        headingDescription: 'Prince Cabs offers reliable Pune to Bangalore Cab services, perfect for business trips, family travel, student journeys, and long-distance tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride along the Pune–Bangalore highway. With professional chauffeurs, flexible schedules, and on-time pickups, we make your interstate journey hassle-free and enjoyable. Experience affordability, comfort, and trusted service with Prince Cabs’ dedicated cab service from Pune to Bangalore.',

        top: 'Top Places to Visit in Bangalore  with Prince Cabs',

"topPlaces": [
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, inspired by England’s Windsor Castle, is a royal landmark of the city. Built in 1878, it features Tudor-style architecture with fortified towers, wooden carvings, and sprawling gardens. The palace interiors showcase paintings, furniture, and memorabilia of the Wadiyar dynasty. Concerts and cultural events are often held here. Visitors enjoy guided tours narrating the palace’s history. It remains a symbol of Bangalore’s regal charm."
  },
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre oasis in the heart of Bangalore, famous for its glasshouse modeled after London’s Crystal Palace. It houses over 1,800 species of plants and centuries-old trees. The annual flower show during Independence Day and Republic Day is a major attraction. Jogging trails, fountains, and lakes make it a recreational hub. Birdwatchers spot parakeets, herons, and mynahs here. Lalbagh is both historic and refreshing."
  },
  {
    "title": "Cubbon Park",
    "description": "Spread over 300 acres, Cubbon Park is Bangalore’s green lung and a favorite spot for walkers and joggers. The park features lush lawns, bamboo groves, fountains, and colonial statues. It also houses the State Central Library, an iconic red building. Families enjoy weekend picnics and toy train rides for kids. Early mornings here are peaceful with fresh air and birdsong. Cubbon Park balances the city’s modern rush with nature’s calm."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is Karnataka’s legislative building and an architectural marvel in Bangalore. Completed in 1956, it blends Dravidian, Rajasthani, and Indo-Saracenic styles. The grand façade, with over 300 rooms and a massive central dome, is illuminated beautifully at night. Though entry is restricted, visitors admire it from outside. It is a proud symbol of Karnataka’s governance. Vidhana Soudha is one of the most photographed landmarks in Bangalore."
  },
  {
    "title": "ISKCON Temple",
    "description": "The ISKCON Sri Radha Krishna Temple in Bangalore is one of the largest ISKCON temples in the world. Built in neo-classical style, it features ornate carvings, gold-plated kalashas, and grand halls. Daily aartis, kirtans, and prasadam distribution create a spiritual atmosphere. Festivals like Janmashtami are celebrated with grandeur. The temple complex also houses cultural programs and a Govinda’s restaurant. It is a blend of devotion and modern architecture."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park, located 22 km from Bangalore, is a wildlife reserve with a zoo, safari, and butterfly park. Visitors can see lions, tigers, elephants, and bears in natural enclosures. The butterfly park houses colorful species in a glass conservatory. Safari rides offer thrilling encounters with wild animals. It is a favorite spot for families and nature lovers. Bannerghatta adds adventure to Bangalore’s attractions."
  },
  {
    "title": "UB City Mall",
    "description": "UB City is Bangalore’s premier luxury mall, known for international brands, fine dining, and modern architecture. Located in the business district, it features designer stores, gourmet restaurants, and rooftop lounges. The amphitheater hosts live music and cultural shows. Art lovers enjoy its galleries and exhibitions. It is a hub for shopping, leisure, and lifestyle. UB City defines Bangalore’s cosmopolitan vibe."
  },
  {
    "title": "Nandi Hills",
    "description": "Nandi Hills, about 60 km from Bangalore, is a popular hill station and sunrise point. The fort at the top was once a summer retreat for Tipu Sultan. Trekking trails, ancient temples, and panoramic views attract visitors year-round. The early morning drive for sunrise is especially popular among youth. Paragliding and cycling add adventure to the visit. Nandi Hills is the city’s most loved weekend getaway."
  },
  {
    "title": "Tipu Sultan’s Summer Palace",
    "description": "Located in the heart of Bangalore, Tipu Sultan’s Summer Palace is built entirely of teak wood. The palace showcases Indo-Islamic architecture with carved arches, balconies, and frescoes. It once served as Tipu Sultan’s summer retreat and seat of power. A small museum displays artifacts from his reign. The palace is surrounded by markets selling handicrafts and antiques. It is a historic gem amidst the modern cityscape."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s most famous shopping hub, buzzing with locals and tourists. It offers clothes, footwear, jewelry, and handicrafts at budget-friendly rates. The lanes are packed with boutiques and street stalls. Bargaining is part of the fun for shoppers. Food joints serving chaats and South Indian snacks add flavor to the experience. Commercial Street reflects Bangalore’s vibrant shopping culture."
  },
  {
    "title": "Wonderla Amusement Park",
    "description": "Wonderla, located 28 km from Bangalore, is one of India’s top amusement and water parks. It features over 60 rides including roller coasters, water slides, and wave pools. The park also offers VR experiences and musical fountains. Families and youngsters spend full days enjoying its attractions. The park is known for cleanliness and safety. Wonderla is the ultimate fun-filled getaway near Bangalore."
  },
  {
    "title": "Jawaharlal Nehru Planetarium",
    "description": "The Jawaharlal Nehru Planetarium is an educational and entertaining destination in Bangalore. It features shows on astronomy, stars, and space exploration. The Science Park and Sky Theatre engage children and adults alike. Special programs on eclipses and celestial events are conducted. School groups often visit as part of learning tours. It inspires curiosity about the universe in young minds. The planetarium is a must-visit for science lovers."
  },
  {
    "title": "Ulsoor Lake",
    "description": "Ulsoor Lake, located near MG Road, is one of the largest lakes in Bangalore. It offers boating facilities with small islands scattered across the water. Early mornings are popular for walking and jogging along the promenade. The lake is a peaceful escape from the city’s hustle. During festivals, the lake area becomes vibrant with cultural activities. Ulsoor Lake is a refreshing urban retreat."
  },
  {
    "title": "Chunchi Falls",
    "description": "Chunchi Falls, about 90 km from Bangalore, is a scenic waterfall on the Arkavati River. The cascading waters surrounded by rocky terrain attract trekkers and photographers. It is especially beautiful during monsoon when the falls are full. The calm atmosphere makes it ideal for picnics. Visitors often combine it with a trip to Mekedatu. Chunchi Falls is a natural getaway near the city."
  },
  {
    "title": "Innovative Film City",
    "description": "Innovative Film City, located on the outskirts of Bangalore, is a theme park offering entertainment, shopping, and adventure. It features film sets, a wax museum, a dinosaur park, and cultural performances. Adventure zones include go-karting, mini-golf, and bungee jumping. Visitors also enjoy shopping at handicraft stalls. It is perfect for families and kids seeking fun-filled experiences. Innovative Film City blends cinema with leisure."
  }
],

    "services": [
    {
      "name": "Pune to Bangalore Innova Cab",
      "description": "Travel comfortably from Pune to Bangalore with our reliable Innova cab service. Perfect for families and groups, our spacious Innova Crysta vehicles offer luxury and convenience for your long-distance journey."
    },
    {
      "name": "Pune to Bangalore Taxi",
      "description": "Affordable and professional taxi service from Pune to Bangalore, featuring a range of cars including Dzire, Etios, and Innova to suit your travel needs. Experience safe and timely trips with expert drivers."
    },
    {
      "name": "Pune to Bangalore Cab Fare",
      "description": "Get transparent and competitive cab fare estimates for Pune to Bangalore trips. Choose from multiple vehicle options and plan your budget with ease for one-way or round trips."
    },
    {
      "name": "Pune to Bangalore Round Trip Cab",
      "description": "Convenient round trip cab bookings from Pune to Bangalore with flexible timings and comfortable cars. Ideal for business travelers, tourists, and families seeking hassle-free travel."
    },
    {
      "name": "Pune to Bangalore Car Rental",
      "description": "Rent a car from Pune to Bangalore with experienced drivers and well-maintained vehicles. Our car rental services offer flexibility, safety, and comfort for your outstation travel."
    },
    {
      "name": "Pune to Bangalore Innova Crysta Round Trip Cab",
      "description": "Premium Innova Crysta round trip cab service from Pune to Bangalore, providing luxury, spacious seating, and excellent service for a comfortable journey to and from Bangalore."
    },
    {
      "name": "Pune to Mangalore Cab",
      "description": "Book affordable and reliable cab service from Pune to Mangalore, perfect for family trips, business, or leisure travel with comfortable vehicles and experienced drivers."
    },
    {
      "name": "Pune to Gulbarga Taxi",
      "description": "Secure taxi services from Pune to Gulbarga with a range of vehicle options and professional drivers, ensuring a smooth and safe journey for all passengers."
    },
    {
      "name": "Pune to Bangalore Dzire Cab",
      "description": "Economical and comfortable Dzire cab service for Pune to Bangalore, ideal for solo travelers and small families seeking affordable travel options."
    },
    {
      "name": "Pune to Bangalore Etios Taxi",
      "description": "Book Etios taxis from Pune to Bangalore for a budget-friendly and efficient travel experience, perfect for city travelers and business commuters."
    },
    {
      "name": "Pune to Bangalore Family Cab",
      "description": "Family-friendly cab services from Pune to Bangalore with spacious vehicles like Innova and Dzire, ensuring comfort and safety for all family members."
    },
    {
      "name": "Pune to Bangalore Affordable Taxi",
      "description": "Get the best affordable taxi options for Pune to Bangalore trips without compromising on safety, punctuality, and service quality."
    },
    {
      "name": "Luxury Pune to Bangalore Innova",
      "description": "Experience luxury travel from Pune to Bangalore with premium Innova Crysta cabs, featuring plush interiors, spacious seating, and expert drivers for an unforgettable journey."
    }
  ],
  "tableData": [
    ["Pune to Bangalore Innova Cab", "Pune to Bangalore Taxi"],
    ["Pune to Bangalore Cab Fare", "Pune to Bangalore Round Trip Cab"],
    ["Pune to Bangalore Car Rental", "Pune to Bangalore Innova Crysta Round Trip Cab"],
    ["Pune to Mangalore Cab", "Pune to Gulbarga Taxi"],
    ["Pune to Bangalore Dzire Cab", "Pune to Bangalore Etios Taxi"],
    ["Pune to Bangalore Family Cab", "Pune to Bangalore Affordable Taxi"],
    ["Luxury Pune to Bangalore Innova"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Bangalore Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable and comfortable cab services from Pune to Bangalore, ideal for business travelers, tourists, and families. Covering approximately 840 kilometers, our service ensures a safe, smooth, and stress-free journey, allowing you to focus on your plans while we handle the travel."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Equipped Vehicles for Long Distance",
        "WhyChoosedescription": "Our fleet features well-maintained sedans and SUVs, including Swift Dzire and Innova, designed for comfort on long journeys. With spacious seating, ample legroom, and sufficient luggage space, coupled with air conditioning, your travel experience is made relaxing and enjoyable throughout the trip."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Expertise in Long-Distance Routes",
        "WhyChoosedescription": "Our professional drivers possess extensive knowledge of the highways and routes connecting Pune and Bangalore. They emphasize safety, efficient route selection, and timely breaks to ensure you arrive refreshed and on time."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Schedule",
        "WhyChoosedescription": "Prince Cabs offers customizable rental packages, including one-way trips, round trips with waiting periods, and multi-day rentals for exploring Bangalore and surrounding areas. Booking is quick and easy via phone, WhatsApp, or online with instant confirmation and flexible cancellation."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Our pricing is upfront and competitive, inclusive of fuel, tolls, driver allowances, and taxes. We accept multiple secure payment options such as UPI, credit/debit cards, net banking, and cash for your convenience and peace of mind."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Measures",
        "WhyChoosedescription": "Every vehicle undergoes thorough cleaning and sanitization before and after each trip. Regular maintenance and safety checks are conducted to ensure the mechanical reliability of the fleet, while essential safety features provide passenger protection."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Travel Experience",
        "WhyChoosedescription": "Our dedicated customer service team is available around the clock to assist with bookings, itinerary adjustments, or any travel concerns, ensuring a smooth, comfortable, and worry-free cab service from Pune to Bangalore."
    }
]































    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab services from Pune to Bangalore?',
        answer: 'Yes, Prince Cabs offers comfortable and reliable cab services for travel from Pune to Bangalore, ideal for business and leisure trips.',
    },
    {
        question: 'What types of vehicles are available for Pune to Bangalore trips?',
        answer: 'We provide a range of vehicles including Swift Dzire, Innova, and Tempo Traveller to suit solo travelers, families, and groups.',
    },
    {
        question: 'How long does the journey from Pune to Bangalore take by cab?',
        answer: 'The journey typically takes around 15 to 18 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a round-trip cab from Pune to Bangalore?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip packages tailored to your travel needs.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for long-distance travel?',
        answer: 'Absolutely! All our vehicles are regularly cleaned, sanitized, and serviced to ensure your safety and comfort throughout the trip.',
    },
    {
        question: 'What are the approximate fares for Pune to Bangalore cab service?',
        answer: 'Fares depend on vehicle type, distance, and duration. Contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a cab from Pune to Bangalore?',
        answer: 'You can book easily through our website or by calling our customer support team with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Ravi Kumar",
        position: "Business Traveler",
        text: "I booked a cab from Pune to Bangalore with Prince Cabs. The service was punctual, and the journey was comfortable throughout.",
        image: "/img/testimonial/testimonial-thumb-bangalore-1.png",
    },
    {
        name: "Ms. Ananya Sharma",
        position: "Tourist",
        text: "Prince Cabs made my Pune to Bangalore trip hassle-free. The cab was clean, and the driver was very professional and friendly.",
        image: "/img/testimonial/testimonial-thumb-bangalore-2.png",
    },
];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Bangalore Cab",
  "description": "Reliable and affordable cab services from Pune to Bangalore, including Innova, Dzire, Etios taxis, and family cabs. Round trip and car rental options available. Also servicing Mangalore and Gulbarga.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Bangalore Innova Cab",
    "Pune to Bangalore Taxi",
    "Pune to Bangalore Cab Fare",
    "Pune to Bangalore Round Trip Cab",
    "Pune to Bangalore Car Rental",
    "Pune to Bangalore Innova Crysta Round Trip Cab",
    "Pune to Mangalore Cab",
    "Pune to Gulbarga Taxi",
    "Pune to Bangalore Dzire Cab",
    "Pune to Bangalore Etios Taxi",
    "Pune to Bangalore Family Cab",
    "Pune to Bangalore Affordable Taxi",
    "Luxury Pune to Bangalore Innova"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Bangalore Cab | Innova, Dzire & Etios Taxi Service</title>
  <meta
    name="description"
    content="Reliable and affordable cab services from Pune to Bangalore including Innova, Dzire, Etios taxis, family cabs, round trip and car rental options. Also covering Mangalore and Gulbarga."
  />
  <meta
    name="keywords"
    content="Pune to Bangalore Innova Cab, Pune to Bangalore Taxi, Pune to Bangalore Cab Fare, Pune to Bangalore Round Trip Cab, Pune to Bangalore Car Rental, Pune to Bangalore Innova Crysta Round Trip Cab, Pune to Mangalore Cab, Pune to Gulbarga Taxi, Pune to Bangalore Dzire Cab, Pune to Bangalore Etios Taxi, Pune to Bangalore Family Cab, Pune to Bangalore Affordable Taxi, Luxury Pune to Bangalore Innova"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/52.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobanglorecab ;